import { useEffect, useState } from 'react';
import { getTimeLeft, type TimeLeft } from '@/lib/format';

export function useCountdown(endsAt: string): TimeLeft {
  const [time, setTime] = useState<TimeLeft>(() => getTimeLeft(endsAt));

  useEffect(() => {
    // Сразу пересчитываем при смене endsAt
    setTime(getTimeLeft(endsAt));

    // Тикаем каждую секунду — но обновляем state только если изменилось
    // отображаемое значение. Это экономит ререндеры для дальних таймеров
    // (где меняется только секунда внутри минуты), и при этом таймер всегда
    // выглядит "живым".
    const id = setInterval(() => {
      const next = getTimeLeft(endsAt);

      setTime((prev) => {
        if (next.isOver && !prev.isOver) {
          clearInterval(id);
          return next;
        }
        // Сравниваем по секундам — на этом масштабе всегда есть разница
        if (
          next.days !== prev.days ||
          next.hours !== prev.hours ||
          next.minutes !== prev.minutes ||
          next.seconds !== prev.seconds
        ) {
          return next;
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(id);
  }, [endsAt]);

  return time;
}